var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7706 11.4377L32.0414 5.16683M35.6248 1.5835L32.0414 5.16683L35.6248 1.5835ZM18.4068 18.8014C19.332 19.7142 20.0674 20.801 20.5707 21.9992C21.0741 23.1973 21.3355 24.4833 21.3399 25.7829C21.3442 27.0825 21.0914 28.3701 20.5961 29.5717C20.1008 30.7732 19.3727 31.8649 18.4537 32.7838C17.5347 33.7028 16.443 34.4309 15.2415 34.9263C14.04 35.4216 12.7523 35.6744 11.4527 35.67C10.1531 35.6657 8.86719 35.4043 7.66901 34.9009C6.47083 34.3975 5.38405 33.6621 4.47126 32.737C2.67624 30.8785 1.683 28.3893 1.70545 25.8056C1.7279 23.2218 2.76425 20.7503 4.5913 18.9232C6.41834 17.0962 8.88989 16.0598 11.4736 16.0374C14.0573 16.0149 16.5465 17.0082 18.4051 18.8032L18.4068 18.8014ZM18.4068 18.8014L25.7706 11.4377L18.4068 18.8014ZM25.7706 11.4377L31.1456 16.8127L37.4164 10.5418L32.0414 5.16683L25.7706 11.4377Z",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.12c0605f53a2c443b6a4087d0fd39c35.svg";
export { ForwardRef as ReactComponent };